@use "../../assets/styles/mixins.scss" as *;

.servicesContent {
  background-color: #022c6b;
  color: #ffff;
  padding: 40px 20px;
  text-align: center;

  p {
    font-size: 24px;
    font-weight: 300;
  }
}

.title {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  font-size: 36px;
}

.servicesItemWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.servicesItemContainer {
  max-width: 1100px;
  margin: 0 auto 0 auto;
}

.servicesItem {
  background-color: #ffff;
  margin: 15px;
  border-radius: 50%;
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #022c6b;

  h2 {
    margin-top: 10px;
    margin-bottom: 0;
    font-weight: 500;
  }

  p {
    font-size: 18px;
    margin-top: 12px;
  }
}

.item {
  padding-left: 40px;
  padding-right: 40px;
  text-align: center;
}

.star {
  padding-left: 25px;
  padding-right: 25px;
}

.virtualCare {
  margin-top: 16px;
}
